export class ApiUrl {
    //Controller
    static EMPLE_C = "/api/Employees/";
    static REPRT_C = "/api/Reports/";
    static SCHDULER_C = "/api/Schedulers/";
    static DEVCE_C = "/api/Devices/";
    static TME_CRD_C = "/api/TimeCard/";
    static PJT_C = "/api/Projects/";
    static SECU_C = "/api/Security/";
    static ACNT_C = "/api/Account/";
    static DIVIS_C = "/api/Division/";
    static FOREC_C = "/api/Forecast/";
    static PAYROLL_C = "/api/PayRollNote/";
    static FLDSTSCD_C = "/api/FieldStatusCodeList/";
    static EQMT_C = "/api/Equipment/";
    static DALYDET_C = "/api/DailyDetails/";
    static TMVOCHR_C = "/api/TMVoucher/";
    static MATE_C = "/api/Material/";
    static SPVRORERN_C = "/api/SupervisorOverrideReason/";

    //Methods
    static GT_EMPLE_M = "GetEmployee";
    static GT_EMPLE_LT_M = "GetEmployeeList";
    static GT_A_EMPLE_M = "GetAllEmployee";
    static GT_A_CT_EMPLE_M = "GetAllActiveEmployees";
    static GT_A_EMPLES_M = "GetAllEmployees";
    static UT_EMPLE_M = "UpdateEmployees";
    static GT_SAVREPSCH_M = "saveScheduler";
    static GT_DELREPSCH_M = "deleteScheduler";
    static GT_REPTSCHDULS_M = "getScheduledReportList";
    static GT_EMLFREPTSCHDULS_M = "GetEmailForReportSchedule";
    static GT_DEVCE_M = "GetDevices";
    static GT_A_DEVCE_M = "GetAllDevices";
    static GT_DEVCE_LT_M = "GetDevicesList";
    static GT_DEVCE_A_EMPLE_M = "GetDeviceAssignedEmployees";
    static GT_DEVCE_A_PJT_M = "GetDeviceAssignedProjects";
    static GT_DEVCE_UN_EMPLE_M = "GetDeviceUnassignedEmployees";
    static GT_DEVCE_UN_PJT_M = "GetDeviceUnassignedProjects";
    static UT_DEVCE_UN_EMPLE_A_PJT_M = "UpdateDevicesEmployeeAndProjects";
    static GT_EMPLEDEVCE_M = "GetEmployeeDevices";
    static UT_EMPLEDEVCE_M = "UpdateEmployeeDevices";
    static GT_Isu_Nte_M = "GetIssueNotes";
    static GT_TME_CRD_DT_M = "GetTimeCardDetails";
    static GT_PJT_LT_M = "GetProjectList";
    static GT_PJTDIV_LT_M = "GetProjectDivisionList";
    static GT_PJT_TSK_DEVCE_M = "GetProjectTaskAndDevices";
    static UT_PJTDEVCE_M = "UpdateProjectDevices";
    static GT_PJT_DTL = "GetProjectDetails";
    static GT_USER_M = "GetUser";
    static GT_A_USR_LT_M = "GetAllUserList";
    static GT_ADD_USER_M = "GetAddUserDetails";
    static SV_USR_M = "SaveUsers";
    static LGN_M = "Login";
    static SSLOT_M = "Logout";
    static GT_LGN_TKN_M = "GetUserLoginToken";
    static LGN_CHECK_M = "LoginSSOCheck";
    static GT_A_DVS_LT_M = "GetDivisionList";
    static GT_DVS_M = "GetDivision";
    static SV_DVS_M = "SaveDivision";
    static GT_USR_DVS_M = "GetUserDivision";
    static GT_ATMT_BY_TMECRD_M = "GetAttachmentsByTimeRecordId";
    static UPDT_PRJ_DTS = "UpdateProjectDetails";
    static GT_DEVCE_DTS_M = "GetDeviceDetails";
    static UPDT_DEVCE_DTS = "UpdateDeviceDetails";
    static LGN_SSO = "LoginSSO";
    static GT_EMP_DIVS_DTL = "GetEmployeeDivisionDetails";
    static GT_FOREC_M = "GetForecastDetails";
    static GT_FOREC_LT_M = "GetForecastList";
    static SV_FOREC_M = "SaveForecast";
    static DL_FOREC_M = "DeleteForecast";
    static GT_PRJT_TSK_CDS_M = "GetProjectTaskCodes";
    static GT_EMPLEPRJDIV_M = "GetEmployeeProjectAndDivision";
    static GT_PYRLNTE_LT_M = "GetPayRollNoteList";
    static GT_PYRLNTE_M = "GetPayRollNote";
    static SV_PYRNTE_M = "SavePayRollNote";
    static DLT_PYRNTE_M = "DeletePayRollNote";
    static GT_USRREPTSCHDULS_M = "GetUserEmailForReportSchedule";
    static GT_CPYDVS_DT = "GetCopyDeviceData";
    static SV_CPY_EMP_PRJ_TDVC = "SaveCopiedDataToDevice";
    static ACTV_OR_DCTV_UR_M = "ActivateOrDeactivateUser";
    static GT_A_FSCDLT_M = "GetFieldStatusCodeList";
    static SV_STSCD_M = "SaveStatusCode";
    static GT_STSCD_M = "GetStatusCodeById";
    static DLT_STSCD_M = "DeleteStatusCodeById";
    static GT_EQMT_LT_M = "GetEquipmentList";
    static GT_EQMT_M = "GetEquipmentById";
    static DLT_EQMT_M = "DeleteEquipmentById";
    static SV_EQMT_M = "SaveEquipment";
    static GT_DALY_DTL_LT_M = "GetDailyDetails"
    static GT_TMVOCHR_LT_M = "GetTMVoucherList";
    static GT_ATMT_BY_TMVOCHR_M = "GetAttachmentsByTMvoucherId";
    static GT_PDF_ATMT_BY_TMVOCHR_M = "GetPDFAttachmentByTMvoucherId";
    static GT_TMR_L="GetTMVoucherRevisionList";
    static GT_MATE_LT_M = "GetAllMaterialList";
    static GT_MATE_M = "GetMaterialById";
    static DLT_MATE_M = "DeleteMaterialById";
    static SV_MATE_M = "SaveMaterialList";

    static GT_ATTST_BTMCRD_ID_M = "GetAttestionByTimeRecordId";

    static SVE_SPVR_ORE_RN_M = "SaveSupervisorOverrideReason";
    static GT_SPVR_ORE_RN_LT_M = "GetSupervisorOverrideReasonList";
    static GT_SPVR_ORE_RN_M = "GetSupervisorOverrideReasonById";
    static DLT_SPVR_ORE_RN_M = "DeleteSupervisorOverrideReasonById";
    static SUBMIT_ARCHIEVE="StartArchive";

    static CR_ATTST_PDF = "CreateAttestationPdf";
};